import Vue from 'vue';
import VueRouter from 'vue-router';
import Constant from '@/lib/constant';

const PrescriptionList = () => import(/* webpackChunkName:'p_prescription' */ '@/pages/prescription/prescriptionList');
const Login = () => import(/* webpackChunkName:'p_login' */ '../pages/login');
const PrescriptionDetail = () =>
  import(/* webpackChunkName:'p_prescription' */ '@/pages/prescription/prescriptionDetail');
const drugAdministration = () => import('../pages/drugAdministration');
const setting = () => import(/* webpackChunkName:'p_setting' */ '../pages/setting');
const shopManagement = () => import(/* webpackChunkName:'p_shopManagement' */ '../pages/shopManagement');
const addShop = () => import(/* webpackChunkName:'p_shopManagement_add' */ '../pages/shopManagement/addShop');
const editorShop = () => import(/* webpackChunkName:'p_shopManagement' */ '../pages/shopManagement/editorShop');
const showShop = () => import(/* webpackChunkName:'p_shopManagement' */ '../pages/shopManagement/showShop');
const settingShop = () => import(/* webpackChunkName:'p_shopManagement' */ '../pages/shopManagement/settingShop');
const areaList = () => import(/* webpackChunkName:'p_shopManagement' */ '../pages/shopManagement/areaList');
const areaDetail = () => import(/* webpackChunkName:'p_shopManagement' */ '../pages/shopManagement/areaDetail');
const areaEdit = () => import(/* webpackChunkName:'p_shopManagement' */ '../pages/shopManagement/area');
const disabledShop = () =>
  import(/* webpackChunkName:'p_shopManagement_disabled' */ '../pages/shopManagement/disabledShop');
const staffManagement = () => import(/* webpackChunkName:'p_staffManagement' */ '../pages/staffManagement');
const addStaff = () => import(/* webpackChunkName:'p_staffManagement' */ '../pages/staffManagement/addStaff');
const editorStaff = () => import(/* webpackChunkName:'p_staffManagement' */ '../pages/staffManagement/editorStaff');
const showStaff = () => import(/* webpackChunkName:'p_staffManagement' */ '../pages/staffManagement/showStaff');
const nopage = () => import(/* webpackChunkName:'p_error' */ '@/pages/error/404/index.vue'); // progress bar style
const noauth = () => import(/* webpackChunkName:'p_error' */ '@/pages/error/401/index.vue'); // progress bar style
const layout = () => import(/* webpackChunkName:'p_layout' */ '../layout/index.vue');
// const home = () => import('@/pages/home');
const dashboard = () => import(/* webpackChunkName:'p_dashboard' */ '@/pages/dashboard');
const waitPrescriptionList = () => import(/* webpackChunkName:'p_prescription' */ '@/pages/waitPrescriptionList');
const waitPrescriptionListMid = () =>
  import(/* webpackChunkName:'p_prescription' */ '@/pages/waitPrescriptionList/mid');
const messageCenter = () => import(/* webpackChunkName:'p_messageCenter' */ '@/pages/messageCenter');
const shopAccount = () => import(/* webpackChunkName:'p_shopAccount' */ '@/pages/shopService/shopAccount');
const addAccountHistory = () =>
  import(/* webpackChunkName:'p_shopAccount_add' */ '@/pages/shopService/shopAccount/addAccountHistory');
const useAccountHistory = () =>
  import(/* webpackChunkName:'p_shopAccount_use' */ '@/pages/shopService/shopAccount/useAccountHistory');
const updatePwd = () => import(/* webpackChunkName:'p_quickRoutes' */ '@/pages/quickRoutes/updatePwd');
const agreementList = () =>
  import(/* webpackChunkName:'p_quickRoutes' */ '@/pages/quickRoutes/agreement/agreementList');
const agreement = () => import(/* webpackChunkName:'p_quickRoutes' */ '@/pages/quickRoutes/agreement/agreement');
const packPrescription = () => import(/* webpackChunkName:'p_prescription' */ '@/pages/prescription/packPrescription');
const chooseConsultType = () => import(/* webpackChunkName:'p_chooseConsultType' */ '@/pages/chooseConsultType');
const applyPrescription = () =>
  import(/* webpackChunkName:'p_applyPrescription' */ '@/pages/chooseConsultType/children/applyPrescription');
const chatHome = () => import(/* webpackChunkName:'p_chatHome' */ '@/pages/chatHome/chatSession');
const chatList = () => import(/* webpackChunkName:'p_chatHome' */ '@/pages/chatHome/chatList');
const punchList = () => import(/* webpackChunkName:'p_punch' */ '@/pages/punch');
const downloadList = () => import(/* webpackChunkName:'p_download' */ '@/pages/download');
const choosePhotoType = () =>
  import(/* webpackChunkName:'p_choosePhotoType' */ '@/pages/chooseConsultType/children/choosePhotoType');
const photoPrescription = () =>
  import(/* webpackChunkName:'p_photoPrescription' */ '@/pages/chooseConsultType/children/photoPrescription');
const yaokaikaiyinliu = () => import(/* webpackChunkName:'yaokaikaiyinliu' */ '@/pages/activity/yaokaikaiyinliu');
const drugsManagement = () => import(/* webpackChunkName:'p_drugsManagement' */ '@/pages/drugsManagement');
const drugsManagementEditor = () => import(/* webpackChunkName:'p_drugsManagement' */ '@/pages/drugsManagement/editor');
const clinicEditor = () => import(/* webpackChunkName:'p_drugsManagement' */ '@/pages/drugsManagement/clinicEditor');
const servicePackage = () =>
  import(/* webpackChunkName:'p_servicePackage' */ '@/pages/shopService/servicePackage/servicePackage');
const renewalStore = () =>
  import(
    /* webpackChunkName:'p_renewalStore' */ '@/pages/shopService/servicePackage/children/renewalStore/renewalStore'
  );
const renewalInfo = () =>
  import(/* webpackChunkName:'p_renewalInfo' */ '@/pages/shopService/servicePackage/children/renewalInfo/renewalInfo');
const renewalOrderList = () =>
  import(
    /* webpackChunkName:'p_renewalOrderList' */ '@/pages/shopService/servicePackage/children/renewalOrderList/renewalOrderList'
  );
const enterpriseWeChat = () => import(/* webpackChunkName:'p_enterpriseWeChat' */ '@/pages/enterpriseWeChat/index');
const o2oAccountManage = () => import(/* webpackChunkName:'o2oAccountManage' */ '@/pages/o2oManage/accountManage/list');
const o2oAccountDetail = () =>
  import(/* webpackChunkName:'o2oAccountDetail' */ '@/pages/o2oManage/accountManage/detail');

const baseRole = Constant.RoleList;
export const router = [
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/404',
    name: '404',
    component: nopage
  },
  {
    path: '/401',
    name: '401',
    component: noauth
  },
  {
    path: '/yaokaikaiyinliu',
    name: 'yaokaikaiyinliu',
    component: yaokaikaiyinliu
  }
];

/*
  title 当前路由的document.title
  roles 当前路由使用权限
  keepAlive 当前路由是否强缓存
  belong 当前路由高亮menu的path
*/

export const asyncRoutes = [
  {
    path: '/quick',
    component: layout,
    children: [
      {
        name: 'updatePwd',
        path: '/updatePwd',
        component: updatePwd,
        meta: {
          title: '修改密码',
          roles: [baseRole.a, baseRole.d, baseRole.b, baseRole.e, baseRole.f]
        }
      },
      {
        name: 'agreement',
        path: '/agreement/:id',
        component: agreement,
        meta: {
          title: '服务协议',
          roles: [baseRole.a]
        }
      },
      {
        name: 'agreementList',
        path: '/agreementList',
        component: agreementList,
        meta: {
          title: '签约信息',
          roles: [baseRole.a]
        }
      }
    ]
  },
  {
    path: '/dashboard',
    component: layout,
    children: [
      {
        path: '',
        component: dashboard,
        name: 'dashboard_index',
        meta: {
          title: '数据看板',
          roles: [baseRole.a, baseRole.c, baseRole.d],
          belong: '/dashboard'
        }
      }
    ],
    meta: {
      title: '数据看板',
      roles: [baseRole.a, baseRole.c, baseRole.d]
    }
  },
  {
    path: '/waitPrescriptionList',
    component: layout,
    children: [
      {
        path: '',
        component: waitPrescriptionList,
        name: 'waitPrescriptionList',
        meta: {
          title: '待审处方',
          roles: [baseRole.b, baseRole.d, baseRole.e, baseRole.f],
          belong: '/waitPrescriptionList'
        }
      }
    ],
    meta: {
      title: '待审处方',
      roles: [baseRole.b, baseRole.d, baseRole.e, baseRole.f]
    }
  },
  {
    path: '/waitPrescriptionListMid',
    component: layout,
    children: [
      {
        path: '',
        component: waitPrescriptionListMid,
        name: 'waitPrescriptionListMid',
        meta: {
          title: '待审处方',
          roles: [baseRole.a, baseRole.b, baseRole.c, baseRole.d, baseRole.e, baseRole.f, baseRole.g, baseRole.h],
          belong: '/waitPrescriptionList'
        }
      }
    ],
    meta: {
      title: '待审处方',
      hide: true,
      roles: [baseRole.a, baseRole.b, baseRole.c, baseRole.d, baseRole.e, baseRole.f, baseRole.g, baseRole.h]
    }
  },
  {
    path: '/prescription',
    name: 'prescription',
    component: layout,
    children: [
      {
        path: '',
        component: packPrescription,
        children: [
          {
            path: '',
            name: 'PrescriptionList',
            component: PrescriptionList,
            meta: {
              title: '处方列表',
              roles: [
                baseRole.a,
                baseRole.b,
                baseRole.c,
                baseRole.d,
                baseRole.e,
                baseRole.f,
                baseRole.h,
                baseRole.i,
                baseRole.j
              ],
              belong: '/prescription',
              trackId: 'zywzpc-page-PrescriptionList'
            }
          },
          {
            path: 'detail/:id',
            name: 'PrescriptionDetail',
            component: PrescriptionDetail,
            meta: {
              title: '处方详情',
              roles: [
                baseRole.a,
                baseRole.b,
                baseRole.c,
                baseRole.d,
                baseRole.e,
                baseRole.f,
                baseRole.h,
                baseRole.i,
                baseRole.j
              ],
              belong: '/prescription',
              noCache: true
            }
          },
          {
            // 兼容老版本处方列表
            path: 'list',
            redirect: '/prescription'
          }
        ]
      }
    ],
    meta: {
      title: '处方列表',
      roles: [
        baseRole.a,
        baseRole.b,
        baseRole.c,
        baseRole.d,
        baseRole.e,
        baseRole.f,
        baseRole.h,
        baseRole.i,
        baseRole.j
      ]
    }
  },

  {
    path: '/shopManagement',
    name: 'shopManagement',
    component: layout,
    children: [
      {
        path: '',
        name: 'shopManagement',
        component: shopManagement,
        meta: {
          title: '门店管理',
          roles: [baseRole.a, baseRole.d, baseRole.c, baseRole.h, baseRole.i, baseRole.j],
          belong: '/shopManagement',
          trackId: 'zywzpc-page-StoreManage'
        }
      },
      {
        path: 'editorShop/:shopId',
        component: editorShop,
        name: 'editorShop',
        meta: {
          title: '编辑门店',
          roles: [baseRole.a, baseRole.c, baseRole.d],
          belong: '/shopManagement',
          noCache: true
        }
      },
      {
        path: 'settingShop/:storeId',
        component: settingShop,
        name: 'settingShop',
        meta: {
          title: '设置',
          roles: [baseRole.a, baseRole.d],
          belong: '/shopManagement',
          noCache: true
        }
      },
      {
        path: 'showShop/:shopId',
        component: showShop,
        name: 'showShop',
        meta: {
          title: '查看门店',
          roles: [baseRole.a, baseRole.d, baseRole.c, baseRole.h, baseRole.i, baseRole.j],
          belong: '/shopManagement'
        }
      },
      {
        name: 'areaList',
        path: 'areaList',
        component: areaList,
        meta: {
          title: '大区设置',
          roles: [baseRole.a],
          belong: '/shopManagement'
        }
      },
      {
        name: 'area',
        path: 'area/:id?',
        component: areaEdit,
        meta: {
          title: '大区操作',
          roles: [baseRole.a],
          belong: '/shopManagement'
        }
      },
      {
        name: 'area',
        path: 'areaDetail/:id',
        component: areaDetail,
        meta: {
          title: '查看大区',
          roles: [baseRole.a],
          belong: '/shopManagement'
        }
      }
    ],
    meta: {
      title: '门店管理',
      roles: [baseRole.a, baseRole.d, baseRole.c, baseRole.h, baseRole.i, baseRole.j]
    }
  },
  {
    path: '/servicePackage',
    component: layout,
    name: 'servicePackage',
    children: [
      {
        path: '',
        name: 'servicePackage',
        component: servicePackage,
        meta: {
          title: '服务套餐',
          belong: '/servicePackage',
          roles: [baseRole.a]
        }
      },
      {
        path: '/renewalStore',
        name: 'renewalStore',
        component: renewalStore,
        meta: {
          title: '续费门店',
          roles: [baseRole.a],
          belong: '/servicePackage'
        }
      },
      {
        path: '/chain_renewalInfo/:id',
        name: 'chainRenewalInfo',
        component: renewalInfo,
        meta: {
          title: '续费信息',
          belong: '/servicePackage',
          roles: [baseRole.a]
        }
      },
      {
        path: '/chain_renewalOrderList',
        name: 'chainRenewalOrderList',
        component: renewalOrderList,
        meta: {
          title: '续费订单',
          belong: '/servicePackage',
          roles: [baseRole.a]
        }
      }
    ],
    meta: {
      title: '服务套餐',
      hide: true,
      roles: [baseRole.a],
      menuClickEventTrackId: 'zywzpc-click-package'
    }
  },
  {
    path: '/shopAccount',
    component: layout,
    name: 'shopAccount',
    children: [
      {
        path: '',
        name: 'shopAccount',
        component: shopAccount,
        meta: {
          belong: '/shopAccount',
          title: '门店账户',
          roles: [baseRole.d, baseRole.a]
        }
      },
      {
        path: 'addAccountHistory',
        name: 'addAccountHistory',
        component: addAccountHistory,
        meta: {
          belong: '/shopAccount',
          title: '点数购买记录',
          roles: [baseRole.d, baseRole.a]
        }
      },
      {
        path: 'useAccountHistory',
        name: 'useAccountHistory',
        component: useAccountHistory,
        meta: {
          belong: '/shopAccount',
          title: '点数变更记录',
          roles: [baseRole.d, baseRole.a]
        }
      },
      {
        path: '/monomer_renewalInfo/:id',
        name: 'monomerRenewalInfo',
        component: renewalInfo,
        meta: {
          title: '续费信息',
          belong: '/shopAccount',
          roles: [baseRole.d, baseRole.a]
        }
      },
      {
        path: '/monomer_renewalOrderList',
        name: 'monomerRenewalOrderList',
        component: renewalOrderList,
        meta: {
          title: '续费订单',
          belong: '/shopAccount',
          roles: [baseRole.d, baseRole.a]
        }
      }
    ],
    meta: {
      title: '门店账户',
      roles: [baseRole.d, baseRole.a],
      menuClickEventTrackId: 'zywzpc-click-storeaccount'
    }
  },

  {
    path: '/staffManagement',
    name: 'staffManagement',
    component: layout,
    children: [
      {
        path: '',
        name: 'staffManagement',
        component: staffManagement,
        meta: {
          title: '职员管理',
          roles: [baseRole.a, baseRole.c, baseRole.d],
          belong: '/staffManagement',
          trackId: 'zywzpc-page-StaffManage'
        }
      },
      {
        path: 'addStaff',
        name: 'addStaff',
        component: addStaff,
        meta: {
          title: '添加职员',
          roles: [baseRole.a, baseRole.c, baseRole.d],
          belong: '/staffManagement',
          noCache: true
        }
      },
      {
        path: 'editorStaff/:staffId',
        name: 'editorStaff',
        component: editorStaff,
        meta: {
          title: '编辑职员',
          roles: [baseRole.a, baseRole.c, baseRole.d],
          belong: '/staffManagement',
          noCache: true
        }
      },
      {
        path: 'showStaff/:staffId',
        name: 'showStaff',
        component: showStaff,
        meta: {
          title: '查看职员',
          roles: [baseRole.a, baseRole.c, baseRole.d],
          belong: '/staffManagement',
          noCache: true
        }
      }
    ],
    meta: {
      title: '职员管理',
      roles: [baseRole.a, baseRole.c, baseRole.d]
    }
  },
  {
    path: '/drugsManagement',
    component: layout,
    name: 'drugsManagement',
    children: [
      {
        path: '',
        name: 'drugsManagementList',
        component: drugsManagement,
        meta: {
          title: '药品管理',
          belong: '/drugsManagement'
        }
      },
      {
        path: 'clinic/:type',
        name: 'clinicEditor',
        component: clinicEditor,
        meta: {
          title: '药品管理',
          belong: '/drugsManagement'
        }
      },
      {
        path: ':type/:spuId?/:skuId?',
        name: 'drugsManagementEditor',
        component: drugsManagementEditor,
        meta: {
          title: '药品管理',
          belong: '/drugsManagement'
        }
      }
    ],
    meta: {
      title: '药品管理',
      roles: [baseRole.d, baseRole.e, baseRole.f]
    }
  },
  {
    path: '/messageCenter',
    component: layout,
    children: [
      {
        path: '',
        name: 'messageCenter',
        component: messageCenter,
        meta: {
          title: '消息中心',
          roles: [baseRole.a, baseRole.b, baseRole.c, baseRole.d, baseRole.e, baseRole.f, baseRole.g]
        }
      }
    ],
    meta: {
      title: '消息中心',
      hide: true,
      roles: [baseRole.a, baseRole.b, baseRole.c, baseRole.d, baseRole.e, baseRole.f, baseRole.g]
    }
  },
  {
    path: '/setting',
    component: layout,
    children: [
      {
        path: '',
        name: 'setting',
        component: setting,
        meta: {
          title: 'setting',
          roles: []
        }
      }
    ],
    meta: {
      title: 'setting',
      hide: true,
      roles: [baseRole.a, baseRole.b, baseRole.c, baseRole.d, baseRole.e, baseRole.f, baseRole.g, baseRole.h]
    }
  },
  {
    path: '/chooseConsultType',
    component: layout,
    name: 'chooseConsultType',
    children: [
      {
        path: '',
        name: 'chooseConsultType',
        component: chooseConsultType,
        meta: {
          title: '申请处方',
          belong: '/chooseConsultType',
          trackId: 'zywzpc-page-ApplyPrescription'
        }
      },
      {
        path: 'applyPrescription/:consultType',
        name: 'applyPrescription',
        component: applyPrescription,
        meta: {
          belong: '/chooseConsultType'
        }
      },
      {
        path: 'choosePhotoType',
        name: 'choosePhotoType',
        component: choosePhotoType,
        meta: {
          belong: '/chooseConsultType'
        }
      },
      {
        path: 'photoPrescription/:photoType',
        name: 'photoPrescription',
        component: photoPrescription,
        meta: {
          title: '拍摄处方',
          belong: '/chooseConsultType',
          parent: [
            {
              belong: '/chooseConsultType/choosePhotoType',
              title: '拍照上传'
            }
          ]
        }
      }
    ],
    meta: {
      title: '申请处方',
      roles: [baseRole.d, baseRole.e, baseRole.f, baseRole.g, baseRole.k]
    }
  },

  {
    path: '/chatList',
    component: layout,
    name: 'chat',
    children: [
      {
        path: '/chatHome/:advisoryId',
        name: 'chatHome',
        component: chatHome,
        meta: {
          title: '咨询详情',
          belong: '/chatList'
        }
      },
      {
        path: '',
        name: 'chatList',
        component: chatList,
        meta: {
          title: '咨询列表',
          trackId: 'zywzpc-page-ConsultationList',
          belong: '/chatList'
        }
      }
    ],
    meta: {
      title: '咨询列表',
      roles: [baseRole.d, baseRole.e, baseRole.f, baseRole.g, baseRole.k]
    }
  },
  {
    path: '/punchList',
    component: layout,
    name: 'punch',
    children: [
      {
        path: '',
        name: 'punchList',
        component: punchList,
        meta: {
          title: '打卡管理',
          belong: '/punchList',
          trackId: 'zywzpc-page-Clockedin'
        }
      }
    ],
    meta: {
      title: '打卡管理',
      roles: [baseRole.a, baseRole.b]
    }
  },
  // enterprise-weChat
  {
    path: '/enterpriseWeChat',
    component: layout,
    name: 'enterpriseWeChat',
    children: [
      {
        path: '',
        name: 'enterpriseWeChat',
        component: enterpriseWeChat,
        meta: {
          title: '企业微信',
          belong: '/enterpriseWeChat'
          // trackId: 'zywzpc-page-DownloadCenter'
        }
      }
    ],
    meta: {
      title: '企业微信',
      roles: [baseRole.a] // 权限仅公司负责人&运营后台开启了「企业微信」才可以看到
    }
  },
  {
    path: '/download',
    component: layout,
    name: 'download',
    children: [
      {
        path: '',
        name: 'downloadList',
        component: downloadList,
        meta: {
          title: '下载中心',
          belong: '/download',
          trackId: 'zywzpc-page-DownloadCenter'
        }
      }
    ],
    meta: {
      title: '下载中心',
      roles: [baseRole.a, baseRole.b, baseRole.c, baseRole.d, baseRole.e, baseRole.f]
    }
  },
  {
    path: '/o2o',
    component: layout,
    name: 'o2o',
    children: [
      {
        path: '',
        name: 'accountManage',
        component: o2oAccountManage,
        meta: {
          title: '快药账户',
          belong: '/o2o'
        }
      },
      {
        path: 'detail',
        name: 'accountDetail',
        component: o2oAccountDetail,
        meta: {
          title: '账户详情',
          belong: '/o2o'
        }
      }
    ],
    meta: {
      title: '智云快药',
      roles: [baseRole.a, baseRole.m]
    }
  },
  {
    path: process.env.VUE_APP_B2B_LINK,
    name: 'b2b',
    meta: {
      title: '智云药城',
      externalLink: true
    }
  }
];

Vue.use(VueRouter);

const createRouter = () =>
  new VueRouter({
    scrollBehavior: () => ({ y: 0, x: 0 }),
    routes: router
  });
const route = createRouter();
export function resetRouter() {
  const newRouter = createRouter();
  router.matcher = newRouter.matcher; // reset router
}
export default route;
